import type { AllRouteEndpoints } from "../routeTypes";

export const apiCalculatedAttributesAppGroupId = "/api/calculated_attributes/:app_group_id";

export const postApiCalculatedAttributesAppGroupIdCacheKeys: AllRouteEndpoints[] = [
  "/api/calculated_attributes/:app_group_id",
];
